module.exports = __webpack_public_path__ + "img/community03.236d1733.png";